import { UpdateCheckoutDataResp } from 'types/api/response/update-checkout-data-resp'

import { api } from './api'
import { moneyObjectHeader } from './money-object-header'

export const getCheckoutData = (transactionId: number) =>
  api.get<UpdateCheckoutDataResp>(`/transactions/${transactionId}/checkout`, {
    headers: moneyObjectHeader,
  })
